import React from 'react'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'

import { updateBookingPayment } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../decl.d'

type UpdateCourierBookingPaymentsProps = InferProps<
  typeof UpdateCourierBookingPayments.propTypes
>

const UpdateCourierBookingPayments = ({
  selectedBooking,
  handleClose,
}: UpdateCourierBookingPaymentsProps) => {
  const { showPageLoader, hidePageLoader, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    status: 'delivered',
    amount: '',
    shipping_chg: '',
    courier_id: '',
    tracking_id: '',
  })

  React.useEffect(() => {
    setData({
      ...data,
      courier_id: selectedBooking.courier_id,
      tracking_id: selectedBooking.tracking_id,
    })
  }, [props])

  const handleSubmit = (e) => {
    e.preventDefault()

    showPageLoader()
    updateBookingPayment(selectedBooking.order_id, data).subscribe(
      (res: any) => {
        hidePageLoader()
        if (res.response.data) {
          handleClose(res.response.data)
        } else {
          if (res.response.error && res.response.field) {
            setError(res.response.error)
          } else {
            showFailure(res.response.error)
          }
        }
      },
    )
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Delivery Status
            </DcText>
            <DcDropDown
              error={
                error.field === 'courier_id' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              options={[
                {
                  label: 'Select Delivery Status',
                  value: '',
                },
                {
                  label: 'Delivered',
                  value: 'delivered',
                },
                {
                  label: 'Returned',
                  value: 'returned',
                },
              ]}
              value={data.status}
              onChange={(e) => {
                setData({
                  ...data,
                  status: e.target.value,
                })
              }}
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Amount Received
            </DcText>
            <DcInput
              error={
                error.field === 'amount' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'number'}
              name={'Amount Received'}
              placeholder={'Amount Received'}
              value={data.amount}
              onChange={(e) => setData({ ...data, amount: e.target.value })}
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Shipping Cost
            </DcText>
            <DcInput
              error={
                error.field === 'shipping_chg' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'number'}
              name={'Shipping Cost'}
              placeholder={'Shipping Cost'}
              value={data.shipping_chg}
              onChange={(e) =>
                setData({ ...data, shipping_chg: e.target.value })
              }
            />
          </DcDiv>
        </FormGroup>
        <FormGroup flexEnd>
          <DcButton variant="primary" type="submit">
            Save
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

UpdateCourierBookingPayments.propTypes = {
  selectedBooking: PropTypes.shape({
    courier_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tracking_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    order_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default UpdateCourierBookingPayments
